import React from "react"
import {FieldViewProps} from "../../render/view";
import GDProjectName from "../../../gd-ui/project-name/project-name";
import {property} from "lodash";

export default function FieldProto_ViewProperty(props: FieldViewProps) {



    return (
        <div className="ui5-prop gray">
           Not implemented for this field ?
        </div>
    )


    const value = props.field.getViewValue(props.model)
    const showIcon = false

    return (
        <GDProjectName className={props.className}
                       projectId={value}
                       type={showIcon ? "with-icon" : "ui5-prop"}
                       hintFullPath={true}/>
    )

}
